// TODO: Rewrite project to TS (add compiler, types, eslint rules)

import "react-image-lightbox/style.css";

import "react-toastify/dist/ReactToastify.css";

import "index.scss";

import "polyfills";

import "core-js/features/promise/all-settled";

import * as Sentry from "@sentry/browser";
import * as serviceWorkerRegistration from "serviceWorkerRegistration";
import { injectSpeedInsights } from "@vercel/speed-insights";
import { inject as injectVercelAnalytics } from "@vercel/analytics";
import Environment from "utils/Environment";
import OpenReplay from "utils/OpenReplay";

(async function() {
  const rootElement = window.document.getElementById("root");

  if (!Environment.checkIsDevMode()) {
    try {
      const { SENTRY_DSN, ENV_TYPE } = Environment.getProcessEnvVars();

      Sentry.init({ dsn: SENTRY_DSN, environment: ENV_TYPE });
    } catch (error) {}
    try {
      OpenReplay.init();
    } catch (error) {}
    try {
      injectVercelAnalytics();
    } catch (error) {}
    try {
      injectSpeedInsights();
    } catch (error) {}
  }

  const { default: Main } = await import("./Main");

  Main.initApp(rootElement);
})();
serviceWorkerRegistration.unregister();
